<template>
<div>
    <Login v-if="current_screen == 'Login'" @enter="afterLogin" @create="current_screen = 'Create'" />
    <Create v-if="current_screen == 'Create'" @enter="afterLogin" @login="current_screen = 'Login'" />
    <Menu v-if="current_screen == 'Menu'" :guest="asGuest"
                  @settings="current_screen = 'Settings', stateSound($event)"
                  @gallery ="current_screen = 'Gallery'"
                  @profile="current_screen = 'Profile', newSelected($event)"
                  @melody="current_screen = 'ChooseSongMelody'"
                  @dance="current_screen = 'ChooseSongDance'"
                  @rhythm="current_screen = 'ChooseSongRhythm'"
                  @sing="current_screen = 'ChooseSongSing'" :character="selected" :somTeclas="somOn" />

    <Logout v-if="Logout_open && !asGuest" @logout="onLogout" @closeModal="Logout_open = !Logout_open" />
    <Profile v-if="current_screen == 'Profile' && !asGuest" :user="authentication" @backMenu="current_screen = 'Menu'" @save="current_screen = 'Menu',
              newSelected($event)" :characterselected="selected" :somTeclas="somOn" />
    <Settings v-if="current_screen == 'Settings'" @backMenu="current_screen = 'Menu',
                  stateSound($event)" @logout="Logout_open = true;" @login="current_screen = 'Login'" :som="somOn" :guest="asGuest" />
    <MelodyGame v-if="current_screen == 'ChooseSongMelody'" :user="authentication" @backToMenu="current_screen = 'Menu'" @openSettings="current_screen = 'Settings'" />
    <DancingGame v-if="current_screen == 'ChooseSongDance'" :user="authentication" @backToMenu="current_screen = 'Menu'" @openSettings="current_screen = 'Settings'" />
    <SingingGame v-if="current_screen == 'ChooseSongSing'" :user="authentication" @backToMenu="current_screen = 'Menu'" @openSettings="current_screen = 'Settings'" />
    <RhythmGame v-if="current_screen == 'ChooseSongRhythm'" :user="authentication" @backToMenu="current_screen = 'Menu'" @openSettings="current_screen = 'Settings'" />
    <Gallery v-if="current_screen == 'Gallery'" :user="authentication" @backToMenu="current_screen = 'Menu'" :somTeclas="somOn" />
</div>
</template>

<script>
import Login from "@/components/Menu/Login.vue";
import Create from "@/components/Menu/Create.vue";
import Gallery from "@/components/Menu/Gallery.vue";
import Menu from "@/components/Menu/Menu.vue";
import Profile from "@/components/Menu/Profile.vue";
import Logout from "@/components/Menu/QuitModal.vue";
import Settings from "@/components/Menu/Settings.vue";
import MelodyGame from "@/components/MelodyGame/MelodyGame.vue";
import DancingGame from "@/components/DancingGame/DancingGame.vue";
import SingingGame from "@/components/SingingGame/SingingGame.vue";
import RhythmGame from "@/components/RhythmGame/RhythmGame.vue";

export default {
    name: "Main",
    components: {
        Login,
        Create,
        Gallery,
        Menu,
        Profile,
        Logout,
        Settings,
        MelodyGame,
        DancingGame,
        SingingGame,
        RhythmGame
    },
    props: {},
    data() {
        return {
            current_screen: "Login",
            selected: 0,
            Logout_open: false,
            somOn: true,
            asGuest: true,
            authentication: {},
            instructions: false
        };
    },
    methods: {
        newSelected(sel) {
            this.selected = sel;
        },
        stateSound(som) {
            this.somOn = som;
        },
        afterLogin(state) {
            if (state === 'guest' || !state['signed-in']) {
                this.asGuest = true;
            } else {
                this.asGuest = false;
                // Store Authentication Tokens, etc
                this.authentication = state;
                this.save();
            }
            this.current_screen = 'Menu';
        },
        onLogout() {
            sessionStorage.removeItem('authentication');
            this.current_screen = 'Login';
            this.Logout_open = !this.Logout_open;
            this.asGuest = true;
        },
        save() {
            if (!this.asGuest && this.authentication !== {}) {
                const parsed = JSON.stringify(this.authentication);
                sessionStorage.setItem('authentication', parsed);
            }
        }
    },
    created() {
        console.log(this.selected)
        console.log(this.somOn);
    },
    mounted() {
        const auth = sessionStorage.getItem('authentication');
        if (auth !== null && auth !== 'null' && auth !== '{}') {
            this.authentication = JSON.parse(auth);
            this.asGuest = false;
            this.current_screen = 'Menu';
        } else {
            this.asGuest = true;
            this.current_screen = 'Login';
        }
    },
    watch: {
        authentication(value, oldValue) {
            if (value !== oldValue) { this.save(); }
        }
    },
    unmounted() {
        this.save();
    },
};
</script>

<style>

</style>
